// Interpreta strings ISO (YYYY-MM-DD) como timezone local (UTC-3 Brasil)
// Evita o bug onde new Date("2025-07-03") é interpretado como UTC e fica um dia antes
export function parseBackendDate(dateString: string): Date {
  if (!dateString) {
    return new Date();
  }

  // Se for timestamp numérico, converte direto
  if (!isNaN(Number(dateString))) {
    return new Date(Number(dateString));
  }

  // Se for string ISO completa (com T), usa new Date direto
  if (dateString.includes('T')) {
    return new Date(dateString);
  }

  // Se for YYYY-MM-DD, interpreta como timezone local
  if (dateString.includes('-')) {
    const [year, month, day] = dateString.split('-').map(Number);
    if (year && month && day) {
      return new Date(year, month - 1, day);
    }
  }

  // Fallback: tenta parse normal
  return new Date(dateString);
}

// Para timestamps completos com hora (ISO8601)
export function parseBackendDateTime(dateString: string): Date {
  return new Date(dateString);
}
